import {Injectable} from '@angular/core';

import {ProjectControlItem} from '../_models/projectControlItem';
import {LoginHelper} from '../helpers';

import {AuthenticationService} from './index';
import {FixDates} from "../_decorators/date.decorator";
import {Load} from "../_decorators/loading.decorator";
import {HttpClient} from "@angular/common/http";
import {IndexConfigService} from "./index.config.service";
import { Observable, of } from 'rxjs';

@Injectable()
export class ProjectControlItemService {
  constructor(public http: HttpClient,
              public authenticationService: AuthenticationService,
              public config: IndexConfigService) {
  }

  @FixDates()
  getById(id: number) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .get<any>(this.config.api + '/api/projectControlItems/projectControlItem/' + id + '')
      ;
  }

  @Load()
  getAll() {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    //console.log(dueDate);

    return this.http
      .get<any>(this.config.api + '/api/projectControlItems/all')
      ;
  }

  exportAssessmentNotes(controlId: number, sectionType: string): Observable<Blob> {
    const tenantName = LoginHelper.getTenantName();
    if (!tenantName || !LoginHelper.getUserToken()) {
      return new Observable<Blob>();
    }
    const url = `${this.config.api}/api/projectcontrols/export/${controlId}/${sectionType}`;
    console.log('Request URL:', url);

    return this.http.get(url, { responseType: 'blob' });
  }

  @FixDates()
  getAllByUser(userId: number, dueDate: string) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    //console.log(dueDate);

    return this.http
      .get<any>(this.config.api + '/api/projectControlItems/user/' + userId + '?duedate=' + dueDate)
      ;
  }

  @FixDates()
  getRecentlyReviewed(userId: number, fromDate: string) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    //console.log(dueDate);

    return this.http
      .get<any>(this.config.api + '/api/projectControlItems/recentlyReviewed/' + userId + '?fromDate=' + fromDate)
      ;
  }

  @FixDates()
  @Load()
  update(id: number, projectControlItem: ProjectControlItem) {

    const tenantName = projectControlItem.tenantName;
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }
    return this.http
      .put(this.config.api + '/api/projectControlItems/update/' + id, projectControlItem)
      ;
  }

  @Load()
  delete(ids: number[], tenantName: string) {

    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .put(this.config.api + '/api/projectControlItems/delete', {ids: ids})
      ;
  }

  @Load()
  switchPolicy(projectControlItemId, policyId, value: boolean) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .get<any>(this.config.api + '/api/projectControlItems/policy/' + projectControlItemId + '/' + policyId + '/' + value)
      ;
  }

  @Load()
  addPoam(projectControlItemId, actionPlanTemplateId, isLink: boolean) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .get<any>(this.config.api + '/api/projectControlItems/poam/' + projectControlItemId + '/' + actionPlanTemplateId + '/' + isLink)
      ;
  }

  @Load()
  deletePoam(actionPlanId) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .delete<any>(this.config.api + '/api/projectControlItems/poam/' + actionPlanId)
      ;
  }

  @Load()
  sendProjectControlItemMessage(text, projectControlItemId) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .post(this.config.api + '/api/projectControlItems/sendMessage', {text, projectControlItemId})
      ;
  }
}
